import React from "react";
import './Footer2.css';



function Footer2() {

  return (
    <div className="footer2">
      <div className="footer2-box1">
        <div className="footer2-box2">Copyright © 2025 Mirolav Žajgla</div>
        <div className="footer2-box4"><a href="https://www.devros.cz/">DevRos</a></div>
        <div className="footer2-box3">Poslední aktualizace: 26.7.2025</div>
      </div>
    </div>
  );
}

export default Footer2;
